import { defineNuxtPlugin } from '@nuxtjs/composition-api';
import freshworks from '~/helpers/freshworks';

export default defineNuxtPlugin(({ store }, inject) => {
  inject('freshworks', freshworks(store));
});
